import { ToastVariant } from "./ToastVariant";

export const ProfileToastMessages = {
  editProfileSuccess: {
    message: "Profile updated successfully",
    variant: ToastVariant.Success,
  },
  editProfileError: {
    message: "Profile update failed",
    variant: ToastVariant.Error,
  },
  Update2FASuccess: {
    message: "Two-factor Authentication updated successfully",
    variant: ToastVariant.Success,
  },
  update2FAError: {
    message: "Two-factor Authentication update failed",
    variant: ToastVariant.Error,
  },
};
